/**
 * Types
 */
export const Types = {
  GET_MODAL_INFORMATION: "invoice/GET_MODAL_INFORMATION",
  RESET: "RESET",
};

/**
 * Reducers
 */
const INITIAL_STATE = {
  modalInformation: {},
  invoices: [],
  bankSlips: []
};

/**
 * Actions
 */
export const Creators = {
  handleModalInformation: (invoices) => ({
    type: Types.GET_MODAL_INFORMATION,
    modalInformation: invoices,
  }),
};

export default function invoiceReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case "SET_INVOICES": 
      return {
        ...state,
        invoices: action.invoices
      };
    case "SET_BANKSLIPS": 
      return {
        ...state,
        bankSlips: action.bankSlips
      };
    case Types.GET_MODAL_INFORMATION:
      return {
        ...state,
        modalInformation: action.modalInformation,
      };
    case Types.RESET:
      return {
        modalInformation: {},
      };
    default:
      return state;
  }
}
